import React, { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import { useSelector } from "react-redux";

import { Typography, createTheme, Popover, Paper } from "@mui/material";


const PREFIX = 'ListenerIcon';

const classes = {
    root: `${PREFIX}-root`,
    triangle: `${PREFIX}-triangle`,
    triangleFiltered: `${PREFIX}-triangleFiltered`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
		position: 'absolute',
		bottom: '0px',
		left: '0px',
		color: theme.palette.grey[500],
		zIndex: '50'
	},

    [`& .${classes.triangle}`]: {
		width: '0px',
		height: '0px',
		border: '0px solid transparent',
		borderTopWidth: '12px',
		borderBottomWidth: '0px',
		borderLeft: '12px solid',
		borderLeftColor: 'theme.palette.grey[500]'
	},

    [`& .${classes.triangleFiltered}`]: {
		width: '0px',
		height: '0px',
		border: '0px solid transparent',
		borderTopWidth: '12px',
		borderBottomWidth: '0px',
		borderLeft: '12px solid',
		borderLeftColor: 'red'
	}
}));

const StyledPaper = styled(Paper)((
	{
		theme
	}
) => ({
	padding: theme.spacing(1)
}));

// Build Triangle CSS https://codepen.io/yukulele/pen/KLnhJ
export default function ListenerIcon({invalid, dataSourceNames}) {

	// App State
	const dataSources = useSelector(state => state.data.dataSources);
	const allFields = useSelector(state => state.data.fields);
	const allAliases = useSelector(state => state.data.aliases);
	const filters = useSelector(state => state.data.filters);

	// Component State
	const [anchorEl, setAnchorEl] = useState(null);
	const [listenersMatched, setListenersMatched] = useState([]);
	const [listeners, setListeners] = useState([]);

	useEffect(() => {

		// Confirm Components DataSource
		const wrappedSources = dataSources.filter(d => {
			const index = dataSourceNames.indexOf(d.name.toLowerCase());
			if (index >= 0) {
				return d;
			} else {
				return null;
			}
		});

		let allListeners = [];
		for (const wds of wrappedSources) {
			const listeners = wds.listeners;
			allListeners = allListeners.concat(listeners);
		}

		allListeners = allListeners.filter(f => f.length > 0);
		allListeners = [...new Set(allListeners)];

		// Swap out the fields for alias'
		for (let l = 0; l < allListeners.length; l++) {
			const lu = allFields.indexOf(allListeners[l]);
			if (lu >= 0) {
				// allListeners[l] = "{0}({1})".format(allAliases[lu], allListeners[l]);
				allListeners[l] = "{0}".format(allAliases[lu]);
			} else {
				allListeners[l] = "No Alias ({0})".format(allListeners[l]);
			}
		}
		allListeners.sort();

		setListeners(allListeners);

		// console.log('wrappedSources', wrappedSources);
		let allFieldFilters = [];
		for (const wds of wrappedSources) {
			const listeners = wds.listeners;

			let appliedFilterField = filters.map(f => {
				return listeners.filter(l => {
					return l.toLowerCase() === f.field.toLowerCase()
				})
			});

			// console.log('appliedFilterField', appliedFilterField);
			if (appliedFilterField) {

				// Flatten the array of arrays and then make unique
				appliedFilterField = [].concat.apply([], appliedFilterField);

				allFieldFilters = allFieldFilters.concat(appliedFilterField);
			}
		}

		// Remove empty strings
		allFieldFilters = allFieldFilters.filter(f => f.length > 0);

		// Make unique
		allFieldFilters = [...new Set(allFieldFilters)];

		// Swap out the fields for alias'
		for (let l = 0; l < allFieldFilters.length; l++) {
			const lu = allFields.indexOf(allFieldFilters[l]);
			if (lu >= 0) {
				// allFieldFilters[l] = "{0}({1})".format(allAliases[lu], allFieldFilters[l]);
				allFieldFilters[l] = "{0}".format(allAliases[lu]);
			} else {
				allFieldFilters[l] = "No Alias ({0})".format(allFieldFilters[l]);
			}
		}
		allFieldFilters.sort();

		setListenersMatched(allFieldFilters);

	}, [filters, dataSourceNames]);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const iconStyle = {};
	if (invalid) {
		iconStyle.color = 'red';
	}

	const open = Boolean(anchorEl);
	const popoverId = open ? 'mouse-over-popover' : undefined;

	if (listenersMatched.length > 0) {
		// return null;
		return (
            <Root>
				<div aria-label="listeners" className={classes.root} style={iconStyle} onMouseEnter={handlePopoverOpen} onMouseLeave={handleClose}>
					<div className={classes.triangleFiltered}></div>
				</div>

				<Popover
					id={popoverId}
					sx={{
						pointerEvents: 'none'
					}}
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					anchorReference="anchorEl"
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					disableRestoreFocus
				>
					<StyledPaper>
						<Typography variant="caption">
							{
								'Filtered By Fields:' + listenersMatched.map((s,i) => {
									let prefix = '';
									if (i+1 <= listenersMatched.length) {
										prefix = ' ';
									}
									return prefix + s;
								})
							}
						</Typography>
					</StyledPaper>
				</Popover>
			</Root>
        );
	}
	else if (listeners.length > 0) {
		return (
			<Root>
				<div aria-label="listeners" className={classes.root} style={iconStyle} onMouseEnter={handlePopoverOpen} onMouseLeave={handleClose}>
					<div className={classes.triangle}></div>
				</div>

				<Popover
					id={popoverId}
					sx={{
						pointerEvents: 'none',
					}}
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					anchorReference="anchorEl"
					anchorOrigin={{
						vertical: 'center',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					disableRestoreFocus
				>
					<StyledPaper>
						<Typography variant="caption">
							{
								'Listening Fields:' + listeners.map((l,i) => {
									let prefix = '';
									if (i+1 <= listeners.length) {
										prefix = ' ';
									}

									return prefix + l;
								})
							}
						</Typography>
					</StyledPaper>
				</Popover>
			</Root>
		)
	}
	else {
		return null;
	}
}
